import { useState } from 'react'
import { Outlet, useMatch } from 'react-router-dom'
import Sidebar from './Sidebar'
import DashboardBackdrop from './DashboardBackdrop'
import { LayoutContext } from '@/contexts/LayoutContext'

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  /**
   * Tam ekran editör sayfalarında ana gezinme çubuğu düşer: editörün kendi sol
   * paneli var ve tuvale yer gerekiyor.
   *
   * ⚠️ Kalıplar **tam** olmalı. Bir zamanlar burada `/strategy/:mapName`
   * yazıyordu; strateji sekmesi bölümlere ayrılıp `/strategy/mac`,
   * `/strategy/noktalar`, `/strategy/defter` adresleri açılınca o kalıp
   * bölümlerin kendisiyle eşleşti ve sekmeler arasında gezinen herkesin
   * gezinme çubuğu kayboldu. Editör artık bölümün **altında** durduğu için
   * kalıp da iki parçalıdır.
   */
  const isStrategyEditor = useMatch('/strategy/:section/:mapName')
  const isStrategicPointsMap = useMatch('/strategic-points/:mapName')
  const fullScreenEditor = !!isStrategyEditor || !!isStrategicPointsMap

  return (
    <div className="relative flex h-screen overflow-hidden">
      {/* Zemin — halka açık siteyle aynı kontur haritası, rotaya göre
          dallanmadan. Bkz. DashboardBackdrop. */}
      <DashboardBackdrop />

      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Content */}
      <div className="relative flex h-full w-full">
        {/* Ana gezinme çubuğu — tam ekran editör sayfalarında düşer */}
        {!fullScreenEditor && (
          <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        )}
        <main className="flex-1 overflow-hidden min-w-0">
          <LayoutContext.Provider value={{ onMenuToggle: () => setSidebarOpen(o => !o) }}>
            <Outlet />
          </LayoutContext.Provider>
        </main>
      </div>
    </div>
  )
}
